<template>
  <component :is="getIcon(icon)" :class="class" v-bind="$attrs" />
</template>

<script setup lang="ts">
  defineProps<{
    icon: string;
    class?:
      | string
      | Record<string, boolean>
      | Array<string | Record<string, boolean>>;
  }>();

  const DEFAULT_ICON = 'SvgoWordpress';

  const toPascalCase = (value: string) =>
    value
      .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
      .replace(/[_\s]+/g, '-')
      .split('-')
      .filter(Boolean)
      .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
      .join('');

  const normalizeIconName = (icon?: string) => {
    if (!icon) {
      return DEFAULT_ICON;
    }

    const trimmedIcon = icon.trim();
    if (!trimmedIcon) {
      return DEFAULT_ICON;
    }

    if (/^(Lazy)?Svgo[A-Z0-9]/.test(trimmedIcon)) {
      return trimmedIcon;
    }

    const withoutPrefix = trimmedIcon.replace(/^svgo-?/i, '');
    const normalized =
      withoutPrefix.toLowerCase() === 'wordpress' ? 'wordpress' : withoutPrefix;
    const componentName = toPascalCase(normalized || 'wordpress');

    return `Svgo${componentName}`;
  };

  const getIcon = (icon: string) => normalizeIconName(icon);
</script>
